const { desenhaQrCode } = require('./miscellaneous');

const WHATSAPP_PASSKEY_VIDEO_YOUTUBE_EMBED =
    "https://www.youtube.com/embed/_lZLmYY0rUI";

/**
 * Evita GETs /kanban/{id} duplicados no mesmo "slot".
 * Slot = div do insere ("kanban" / "minhas-oportunidades") ou "atualiza".
 * Assim minhas + kanban ainda podem carregar juntos, mas 2× atualiza (mensagem + sync)
 * não disparam em paralelo.
 */
const kanbanCardFetchInFlight = new Set();

function chaveKanbanCardFetch(oportunidadeId, slot) {
    return `${String(oportunidadeId)}:${String(slot)}`;
}

function marcarKanbanCardFetchInFlight(oportunidadeId, slot) {
    const key = chaveKanbanCardFetch(oportunidadeId, slot);
    if (kanbanCardFetchInFlight.has(key)) {
        return false;
    }
    kanbanCardFetchInFlight.add(key);
    return true;
}

function liberarKanbanCardFetchInFlight(oportunidadeId, slot) {
    kanbanCardFetchInFlight.delete(chaveKanbanCardFetch(oportunidadeId, slot));
}

function haQualquerKanbanCardFetchInFlight(oportunidadeId) {
    const prefix = `${String(oportunidadeId)}:`;
    for (const key of kanbanCardFetchInFlight) {
        if (key.startsWith(prefix)) {
            return true;
        }
    }
    return false;
}

export function buscaCEP(cep, context) {
    if (cep.length < 9) {
        return;
    }

    $("#overlayer-loading").addClass("show-overlayer");
    $.ajax({
        url: siteUrl(`/cidades/cep/${cep}`),
        type: "get",
        success: function (res) {
            if (!res.error && res.dados) {
                const { busca, cidades, estado_id, cidade_id } = res.dados;
                if (!window.dadosEnderecoCCL) {
                    $("#rua", context).val(busca.logradouro);
                }
                
                $("#bairro", context).val(busca.bairro);

                if (estado_id) {
                    $(".js-select-estados", context).val(estado_id);
                    $(".js-select-cidades option", context).remove();
                    cidades.forEach(function (item) {
                        $(".js-select-cidades", context).append(
                            `<option value="${item.id}">${item.value}</option>`
                        );
                    });
                    if (cidade_id) {
                        $(".js-select-cidades", context).val(cidade_id);
                    }
                }
                $("#numero", context).trigger("focus");
            }
            $("#overlayer-loading").removeClass("show-overlayer");
        },
    });
}

function aplicarFontAwesomeSvg(elemento) {
    if (!elemento || typeof window === "undefined") {
        return;
    }

    const fontAwesome = window.FontAwesome;

    if (fontAwesome && fontAwesome.dom && typeof fontAwesome.dom.i2svg === "function") {
        fontAwesome.dom.i2svg({ node: elemento });
    }
}

function restaurarInterfaceAguardandoQrCode(context) {
    const alerta = $(".js-whatsapp-qrcode-alerta", context);

    alerta
        .removeClass("alert-warning")
        .addClass("alert-success")
        .text("Sessão iniciada, aguardando QR Code");
}

function mostrarInterfacePasskeyDuplaAutenticacao(context, sessaoId, passkeyExtensaoUrl) {
    const rowQrCode = $(`.js-row-whatsapp-web-qrcode`, context);

    rowQrCode.data("passkey-ativo", true);

    if (rowQrCode.data("passkey-renderizado")) {
        return;
    }

    rowQrCode.data("passkey-renderizado", true);

    const alerta = $(".js-whatsapp-qrcode-alerta", context);

    alerta
        .removeClass("alert-success")
        .addClass("alert-warning")
        .text(
            "Este WhatsApp necessita de dupla autenticação para estabelecer a conexão."
        );

    const urlExtensao = passkeyExtensaoUrl || siteUrl(
        `/painel/whatsapp-web/passkey-extensao/${sessaoId}`
    );
    const saidaQrCode = document.getElementById("js-saida-qrcode");

    saidaQrCode.innerHTML = `
        <div class="js-whatsapp-passkey-conteudo">
            <div class="js-whatsapp-passkey-icone">
                <i class="fas fa-laptop fa-4x text-muted"></i>
            </div>
            <p class="lead mb-3">Dupla autenticação necessária</p>
            <div class="js-whatsapp-passkey-instrucoes text-left px-3 mb-3">
                <p class="font-weight-bold mb-2">Como conectar</p>
                <ol class="js-whatsapp-passkey-passo-lista pl-3 mb-0">
                    <li>
                        <strong>Baixar a extensão:</strong>
                        a extensão possui as credenciais de autenticação da sessão do WhatsApp
                        para que a Eloca possa ter acesso ao telefone.
                    </li>
                    <li>
                        <strong>Descompactar:</strong>
                        após realizar o download da extensão, descompacte o arquivo nos arquivos do dispositivo.
                    </li>
                    <li>
                        <strong>Modo desenvolvedor:</strong>
                        abra a página de extensões do navegador e habilite o modo desenvolvedor.
                    </li>
                    <li>
                        <strong>Importar a extensão:</strong>
                        importe a pasta descompactada da credencial de autenticação.
                    </li>
                    <li>
                        <strong>Abrir o WhatsApp Web:</strong>
                        clique no botão "Abrir WhatsApp Web" nesta página do Eloca.
                    </li>
                    <li>
                        <strong>Abrir a extensão Eloca:</strong>
                        dentro da página do WhatsApp, no canto superior direito da tela,
                        clique no ícone das extensões e selecione a extensão Eloca instalada.
                    </li>
                    <li>
                        <strong>Assinar o passkey:</strong>
                        clique em "Assinar com a Eloca" e siga com a autenticação.
                    </li>
                    <li>
                        <strong>Confirmar no telefone:</strong>
                        por último, complete as confirmações no telefone.
                    </li>
                </ol>
            </div>
            <div class="js-whatsapp-passkey-acoes d-flex flex-wrap justify-content-center align-items-center">
                <a
                    href="${urlExtensao}"
                    class="btn btn-success mr-2 mb-2 js-whatsapp-passkey-download"
                >
                    <i class="fas fa-download mr-1"></i>
                    Baixar extensão
                </a>
                <a
                    href="https://web.whatsapp.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-outline-success mb-2 js-whatsapp-passkey-abrir-whatsapp"
                >
                    <i class="fas fa-external-link-alt mr-1"></i>
                    Abrir WhatsApp Web
                </a>
            </div>
            <div class="js-whatsapp-passkey-video mt-3 px-3 w-100">
                <p class="small text-muted mb-2">Siga também o exemplo do vídeo abaixo:</p>
                <div class="video-container">
                    <iframe
                        src="${WHATSAPP_PASSKEY_VIDEO_YOUTUBE_EMBED}"
                        title="Tutorial de conexão WhatsApp com extensão Eloca"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
        </div>
    `;

    aplicarFontAwesomeSvg(saidaQrCode.querySelector(".js-whatsapp-passkey-conteudo"));
}

export function qrCodeAjax(context, sessaoId) {
    console.log("qrCodeAjax");
    if ($(`.js-row-whatsapp-web-qrcode`, context).length) {
        const rowQrCode = $(`.js-row-whatsapp-web-qrcode`, context);
        const passkeyAtivo = rowQrCode.data("passkey-ativo") === true;

        $.ajax({
            url: siteUrl("/painel/whatsapp-web/qrcode-ajax/" + sessaoId),
            type: "get",
            success: function (res) {
                if (res.live) {
                    window.location.href = siteUrl(
                        `/painel/fluxo-oportunidades`
                    );
                    return;
                }

                if (passkeyAtivo || res.passkeySolicitado) {
                    mostrarInterfacePasskeyDuplaAutenticacao(
                        context,
                        sessaoId,
                        res.passkeyExtensaoUrl
                    );
                    return;
                }

                restaurarInterfaceAguardandoQrCode(context);

                if (res.sucesso) {
                    if (res.qrCode == 500) {
                        $('#js-saida-qrcode').html("<b class='text-danger'>Limite de QR Codes atingido, por favor, recarregue a página</b>");
                        return;
                    }
                    desenhaQrCode(
                        document.getElementById("js-saida-qrcode"),
                        res.qrCode
                    );
                }
            },
            error: function (error) {
                console.log(error);
            },
        });
    }
}

export function calcChargeValue() {
    let novoValorTotalCobranca = 0.0;

    $(".js-modal-cobranca .js-row-cobranca").each(function () {
        if ($(".js-checkbox-cobranca", this).is(":checked")) {
            novoValorTotalCobranca += parseFloat(
                $(".js-input-value-cobranca", this)
                    .val()
                    .replace(".", "")
                    .replace(",", ".")
            );
        }
    });

    $(".valorTotalCobranca").val(
        novoValorTotalCobranca.toFixed(2).replace(".", ",")
    );
}

function isKanbanV2() {
    return Boolean($("#kanban").data("kanban-v2"));
}

function buildKanbanCardUrl(oportunidadeId) {
    let url = siteUrl("/painel/fluxo-oportunidades/kanban/" + oportunidadeId);
    if (
        isKanbanV2() &&
        typeof window.fluxoKanbanV2SerializeFilters === "function"
    ) {
        const qs = window.fluxoKanbanV2SerializeFilters();
        if (qs) {
            url += (url.indexOf("?") >= 0 ? "&" : "?") + qs;
        }
    }
    return url;
}

/**
 * Insere o HTML do card na fase correta.
 * Master: visible=false no V2, ordenação V2.
 * Branch: respeita faseId (e res.fase_id) em qualquer div, com fallback de lista.
 * @returns {boolean} true se o card foi prependado
 */
function prependKanbanCardLi(res, div, faseIdFallback) {
    if (!res || res.error || !res.li) {
        return false;
    }
    if (isKanbanV2() && res.visible === false) {
        return false;
    }

    // Branch: res.fase_id quando vier; senão faseId do WS. Master no V2 também prioriza res.fase_id.
    const targetFaseId =
        res.fase_id != null && res.fase_id !== ""
            ? res.fase_id
            : faseIdFallback;

    let $ul = $();
    if (targetFaseId != null) {
        $ul = $(`#${div} #sort-fase-${targetFaseId}`).first();
    }
    if (!$ul.length) {
        // Branch: seletor mais específico; master: primeiro ul da fase
        $ul = $(`#${div} .js-fase:first ul.lista-oportunidades`).first();
    }
    if (!$ul.length) {
        $ul = $(`#${div} .js-fase:first ul`).first();
    }
    if ($ul.length) {
        $ul.prepend(res.li);
    }
    if (
        isKanbanV2() &&
        typeof window.fluxoKanbanV2OrdenaOportunidades === "function"
    ) {
        window.fluxoKanbanV2OrdenaOportunidades(document);
    }
    return $ul.length > 0;
}

export function insereOportunidadeKanban(oportunidadeId, div, faseId) {
    // Branch: evita GET duplicado no mesmo slot (kanban / minhas-oportunidades)
    if (!marcarKanbanCardFetchInFlight(oportunidadeId, div)) {
        return;
    }
    $.ajax({
        url: buildKanbanCardUrl(oportunidadeId),
        type: "GET",
        xhrFields: {
            withCredentials: true,
        },
        success: function (res) {
            if (res.error) {
                return;
            }

            // Branch: evita card duplicado (ex.: coluna V2 ainda vai paginar este id).
            $(`#${div} li.js-op-${oportunidadeId}`).remove();

            const inseriu = prependKanbanCardLi(res, div, faseId);

            // Master: no V2 sempre notifica (inclui visible=false). Branch: notifica ao inserir.
            if (inseriu || isKanbanV2()) {
                $(document).trigger("eloca:kanban-cards-changed");
            }
        },
        complete: function () {
            liberarKanbanCardFetchInFlight(oportunidadeId, div);
        },
    });
}

/**
 * Recarrega o HTML do card e coloca na fase indicada (mesmo pipeline do kanban atual).
 */
export function atualizaCardOportunidadeKanbanNaFase(oportunidadeId, faseId) {
    // Branch: se já há insere/atualiza em curso para este id, não dispara outro GET.
    if (
        haQualquerKanbanCardFetchInFlight(oportunidadeId) ||
        !marcarKanbanCardFetchInFlight(oportunidadeId, "atualiza")
    ) {
        return;
    }
    $.ajax({
        url: buildKanbanCardUrl(oportunidadeId),
        type: "GET",
        xhrFields: {
            withCredentials: true,
        },
        success: function (res) {
            if (res.error) {
                return;
            }
            // Master: filtro de visibilidade do V2
            if (isKanbanV2() && res.visible === false) {
                $(`li.js-op-${oportunidadeId}`).remove();
                $(document).trigger("eloca:kanban-cards-changed");
                return;
            }
            // Branch: evita clones se outro GET (insere) ainda terminar depois
            $(`li.js-op-${oportunidadeId}`).remove();

            const alvoFaseId =
                res.fase_id != null && res.fase_id !== ""
                    ? res.fase_id
                    : faseId;
            let alvo = alvoFaseId
                ? $(`#kanban #sort-fase-${alvoFaseId}`).first()
                : $();
            if (!alvo.length) {
                alvo = $("#kanban .js-fase:first ul.lista-oportunidades").first();
            }
            if (!alvo.length) {
                alvo = $("#kanban .js-fase:first ul").first();
            }
            if (alvo.length && res.li) {
                alvo.prepend(res.li);
            }
            if (
                isKanbanV2() &&
                typeof window.fluxoKanbanV2OrdenaOportunidades === "function"
            ) {
                window.fluxoKanbanV2OrdenaOportunidades(document);
            }
            $(document).trigger("eloca:kanban-cards-changed");
        },
        complete: function () {
            liberarKanbanCardFetchInFlight(oportunidadeId, "atualiza");
        },
    });
}

/**
 * Atualiza o HTML do card no lugar (mantém a posição na coluna).
 * Usado após mover fase no sortable para refrescar badge de tempo da nova fase.
 */
export function atualizaHtmlCardOportunidadeKanban(oportunidadeId) {
    const $cards = $(`li.js-op-${oportunidadeId}`);
    if (!$cards.length) {
        return;
    }
    const $card = $cards.first();
    $cards.not($card).remove();

    $.ajax({
        url: buildKanbanCardUrl(oportunidadeId),
        type: "GET",
        xhrFields: {
            withCredentials: true,
        },
        success: function (res) {
            if (res.error || !res.li) {
                return;
            }
            if (isKanbanV2() && res.visible === false) {
                $(`li.js-op-${oportunidadeId}`).remove();
                $(document).trigger("eloca:kanban-cards-changed");
                return;
            }
            const $atual = $(`li.js-op-${oportunidadeId}`).first();
            if ($atual.length) {
                $(`li.js-op-${oportunidadeId}`).not($atual).remove();
                $atual.replaceWith(res.li);
            } else {
                prependKanbanCardLi(res, "kanban", res.fase_id);
            }
            if (
                isKanbanV2() &&
                typeof window.fluxoKanbanV2OrdenaOportunidades === "function"
            ) {
                window.fluxoKanbanV2OrdenaOportunidades(document);
            }
            $(document).trigger("eloca:kanban-cards-changed");
        },
    });
}

export function enviaOportunidadeParaOReact(oportunidadeId) {
    $.ajax({
        url: siteUrl(
            "/painel/fluxo-oportunidades/oportunidade/" + oportunidadeId
        ),
        type: "GET",
        xhrFields: {
            withCredentials: true,
        },
        success: function (res) {
            if (!res.error) {
                const iframe =
                    document.getElementById("react-app").contentWindow;
                const message = {
                    oportunidade: res.oportunidade,
                };

                iframe.postMessage(message, "*");
            }
        },
    });
}

export function buscarFasePipelines(id, classeSelect) {
        $.ajax({
            url: siteUrl(`/painel/oportunidades-pipelines/listar-fases/${id}`),
            type: "get",
            xhrFields: {
                withCredentials: true
            },
            success: function (res) {
                if (res.error) {
                    showToastDanger(context, res.message);
                } else {
                    $(classeSelect).html("");
                    if (Array.isArray(res.fases)) {
                        res.fases.forEach((fase) => {
                            $(classeSelect).append(
                                `<option value="${fase.id}">${fase.value}</option>`
                            );
                        });
                    } else {
                        $(classeSelect).append(
                            `<option value=""> </option>`
                        );
                    }
                    
                }
            },
            error: function (res) {
                showToastDanger(context, res.message);
            },
        });
    }

export function buscarTiposAtendimentoPorPipeline(id, classeSelect) {
    const pipelineId = id || "";
    const $select = $(classeSelect);
    if (!$select.length) {
        return;
    }

    $.ajax({
        url: siteUrl(
            `/painel/oportunidades-tipos-atendimentos/listar-por-pipeline/${pipelineId}`
        ),
        type: "get",
        xhrFields: {
            withCredentials: true,
        },
        success: function (res) {
            if (res.error) {
                showToastDanger(context, res.message);
                return;
            }

            const valorAtual = $select.val();
            $select.html("");
            $select.append('<option value=""></option>');

            if (Array.isArray(res.tipos)) {
                res.tipos.forEach((tipo) => {
                    $select.append(
                        `<option value="${tipo.id}">${tipo.value}</option>`
                    );
                });
            }

            if (
                valorAtual &&
                $select.find(`option[value="${valorAtual}"]`).length
            ) {
                $select.val(valorAtual);
            }
        },
        error: function (res) {
            showToastDanger(
                context,
                (res && res.message) || "Falha ao listar tipos de atendimento."
            );
        },
    });
}
